<template>
    <div class="cabinet-nav cabinet-nav--public flex flex-justify-sb">
        <div class="cabinet-nav__header flex flex-align-center">
            <i class="cabinet-nav__icon cabinet-nav__icon--group-ellipse"></i>
            <router-link
                to="/"
                class="cabinet-nav__logo--goldnet-market"
            ></router-link>
        </div>

        <div class="cabinet-nav-links">
            <ul class="cabinet-nav-list">
                <li class="cabinet-nav-list__item cabinet-nav-list__item--home">
                    <router-link
                        to="/account"
                        exact
                        class="cabinet-nav-list__link flex flex-align-center	js-menu-link"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--home-2"
                        ></i>
                        <div class="cabinet-nav-list__link-title">Главная</div>
                    </router-link>
                </li>

                <li class="cabinet-nav-list__item">
                    <a
                        v-if="isMobile"
                        href="javascript:void(0)"
                        class="cabinet-nav-list__link	cabinet-nav-list__link--catalog	flex flex-align-center js-menu-link js-catalog-button-mobile"
                        @click="showMenu"
                    >
                        <i
                            class="cabinet-nav__icon	cabinet-nav__icon--three-strips"
                        ></i>
                        <div class="cabinet-nav-list__link-title">Каталог</div>
                    </a>
                    <router-link
                        v-else
                        to="/account/catalog"
                        exact
                        class="cabinet-nav-list__link	cabinet-nav-list__link--catalog	flex flex-align-center js-menu-link js-catalog-button-mobile"
                    >
                        <i
                            class="cabinet-nav__icon	cabinet-nav__icon--three-strips"
                        ></i>
                        <div class="cabinet-nav-list__link-title">Каталог</div>
                    </router-link>

                    <div class="cabinet-nav__category-menu category-menu">
                        <div v-if="categories" class="category-menu__left">
                            <ul
                                v-for="categorie in categories.slice(
                                    0,
                                    Math.floor(categories.length / 2)
                                )"
                                :key="categorie.CategoryID"
                                class="category-menu__list"
                            >
                                <li class="category-menu__list-item--title">
                                    <router-link
                                        :to="{
                                            name: 'CategoryID',
                                            params: { id: categorie.CategoryID }
                                        }"
                                    >
                                        {{ categorie.Name }}
                                    </router-link>
                                </li>

                                <li
                                    v-for="type in sortedCategoryTypes(
                                        categorie.types
                                    )"
                                    :key="type.TypeID"
                                    class="category-menu__list-item"
                                >
                                    <router-link
                                        :to="{
                                            name: 'CategoryID',
                                            params: {
                                                id: type.CategoryID,
                                                filter2SubcategoriesFromRoute: type
                                            }
                                        }"
                                    >
                                        {{ type.Name }}
                                    </router-link>
                                </li>
                            </ul>
                        </div>

                        <div v-if="categories" class="category-menu__right">
                            <ul
                                v-for="categorie in categories.slice(
                                    Math.ceil(categories.length / 2),
                                    categories.length
                                )"
                                :key="categorie.CategoryID"
                                class="category-menu__list"
                            >
                                <li class="category-menu__list-item--title">
                                    <router-link
                                        :to="{
                                            name: 'CategoryID',
                                            params: { id: categorie.CategoryID }
                                        }"
                                    >
                                        {{ categorie.Name }}
                                    </router-link>
                                </li>

                                <li
                                    v-for="type in sortedCategoryTypes(
                                        categorie.types
                                    )"
                                    :key="type.TypeID"
                                    class="category-menu__list-item"
                                >
                                    <router-link
                                        :to="{
                                            name: 'CategoryID',
                                            params: {
                                                id: type.CategoryID,
                                                filter2SubcategoriesFromRoute: type
                                            }
                                        }"
                                    >
                                        {{ type.Name }}
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <transition name="show-mobile-menu">
                        <div
                            v-if="isHamburgerMenu || isHamburgerSubMenu"
                            class="cabinet__mobile-menu"
                        >
                            <transition name="show-main-mobile-menu">
                                <div
                                    v-if="isHamburgerMenu"
                                    class="cabinet__hamburger-menu js-catalog-menu-mobile"
                                >
                                    <div
                                        class="cabinet__hamburger-menu-item cabinet__hamburger-menu-item--head	d-flex align-items-center	justify-content-between"
                                    >
                                        <div
                                            class="cabinet__hamburger-menu-title"
                                        >
                                            Каталог
                                        </div>
                                        <div
                                            class="cabinet__hamburger-menu-close	js-catalog-close-mobile"
                                            @click="closeHamburgerMenu"
                                        ></div>
                                    </div>
                                    <a
                                        v-for="categorie in categories"
                                        :key="categorie.CategoryID"
                                        href="javascript:void(0)"
                                        class="cabinet__hamburger-menu-item	d-flex align-items-center	justify-content-between	js-catalog-category-mobile"
                                        @click="
                                            selectCategoryType(
                                                categorie.CategoryID
                                            )
                                        "
                                    >
                                        <div
                                            class="cabinet__hamburger-menu-text"
                                        >
                                            {{ categorie.Name }}
                                        </div>
                                        <div
                                            class="cabinet__hamburger-menu-arrow"
                                        ></div>
                                    </a>
                                    <a
                                        href="http://russianjeweller.ru"
                                        target="_blank"
                                        class="cabinet__hamburger-menu-item	d-flex align-items-center  justify-content-between	js-catalog-category-mobile"
                                    >
                                        <div
                                            class="cabinet__hamburger-menu-text"
                                        >
                                            Русский Ювелир

                                            <p
                                                class="cabinet__hamburger-menu-text--subtitle"
                                            >
                                                Проект журнала "Русский Ювелир"
                                                <span class="no-wrap"
                                                    >(издается с 1996 г.)</span
                                                >
                                            </p>
                                        </div>
                                    </a>
                                </div>
                            </transition>

                            <transition name="show-sub-mobile-menu">
                                <div
                                    v-if="isHamburgerSubMenu"
                                    class="cabinet__hamburger-submenu	js-catalog-submenu-mobile"
                                >
                                    <div
                                        class="cabinet__hamburger-menu-item cabinet__hamburger-menu-item--head	d-flex align-items-center	justify-content-between"
                                    >
                                        <div
                                            class="cabinet__hamburger-menu-back js-catalog-back-mobile"
                                            @click="hamburgerMenuBack"
                                        ></div>
                                        <div
                                            class="cabinet__hamburger-menu-close	js-catalog-close-mobile"
                                            @click="closeHamburgerMenu"
                                        ></div>
                                    </div>
                                    <a
                                        href="javascript:void(0)"
                                        class="cabinet__hamburger-menu-item cabinet__hamburger-menu-item--title d-flex	align-items-center justify-content-between"
                                        @click="
                                            switchingFromMobileMenu(
                                                activeCategorie
                                            )
                                        "
                                    >
                                        <div
                                            class="cabinet__hamburger-menu-title"
                                        >
                                            {{ activeCategorie.Name }}
                                        </div>
                                    </a>
                                    <a
                                        v-for="type in sortedTypesOfActiveCategory(
                                            activeCategorie.types
                                        )"
                                        :key="type.TypeID"
                                        href="javascript:void(0)"
                                        class="cabinet__hamburger-menu-item	d-flex align-items-center	justify-content-between"
                                        @click="switchingFromMobileMenu(type)"
                                    >
                                        <div
                                            class="cabinet__hamburger-menu-text"
                                        >
                                            {{ type.Name }}
                                        </div>
                                    </a>
                                </div>
                            </transition>
                        </div>
                    </transition>

                    <ul class="cabinet-nav-list--sub-list">
                        <li
                            v-for="categorie in categories"
                            :key="categorie.CategoryID"
                            class="cabinet-nav-list__item"
                        >
                            <router-link
                                :to="
                                    `/account/catalog/category/${categorie.CategoryID}`
                                "
                                class="cabinet-nav-list__link flex flex-align-center	js-menu-link"
                            >
                                <div class="cabinet-nav-list__link-title">
                                    {{ categorie.Name }}
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </li>

                <li class="cabinet-nav-list__item">
                    <router-link
                        to="/account/brands"
                        class="cabinet-nav-list__link flex flex-align-center js-menu-link"
                    >
                        <i class="cabinet-nav__icon cabinet-nav__icon--tag"></i>
                        <div class="cabinet-nav-list__link-title">Бренды</div>
                    </router-link>
                </li>

                <li
                    class="cabinet-nav-list__item cabinet-nav-list__item--basket"
                >
                    <router-link
                        to="/account/cart"
                        class="cabinet-nav-list__link flex flex-align-center js-menu-link"
                    >
                        <i class="cabinet-nav__icon cabinet-nav__icon--basket">
                            <span
                                v-if="cartCount > 0"
                                class="cabinet-nav-list__quantity-in-the-basket"
                                >{{ cartCount > 99 ? '99+' : cartCount }}</span
                            >
                        </i>
                        <div class="cabinet-nav-list__link-title">Корзина</div>
                    </router-link>
                </li>

                <li
                    class="cabinet-nav-list__item cabinet-nav-list__item--lists"
                >
                    <router-link
                        to="/account/lists"
                        class="cabinet-nav-list__link flex flex-align-center js-menu-link"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--star"
                        ></i>
                        <div class="cabinet-nav-list__link-title">Списки</div>
                    </router-link>
                </li>

                <li
                    class="cabinet-nav-list__item cabinet-nav-list__item--orders"
                >
                    <router-link
                        to="/account/orders"
                        class="cabinet-nav-list__link flex flex-align-center js-menu-link"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--box-open"
                        ></i>
                        <div class="cabinet-nav-list__link-title">Заказы</div>
                    </router-link>
                </li>

                <li
                    class="cabinet-nav-list__item cabinet-nav-list__item--russian-jeweler"
                >
                    <a
                        href="http://russianjeweller.ru"
                        target="_blank"
                        class="cabinet-nav-list__link flex js-menu-link"
                    >
                        <!-- <i class="cabinet-nav__icon cabinet-nav__icon--russian-jeweler"></i> -->
                        <div class="cabinet-nav-list__link-title">
                            Русский Ювелир

                            <p class="cabinet-nav-list__link-title--subtitle">
                                Проект журнала "Русский Ювелир" (издается с 1996
                                г.)
                            </p>
                        </div>
                    </a>
                </li>

                <li
                    ref="dropdownCabinetNavFooterMobile"
                    class="cabinet-nav-list__item"
                >
                    <a
                        href="javascript:void(0)"
                        class="cabinet-nav-footer__link cabinet-nav-footer__link--yet flex flex-align-center js-menu-link d-flex d-md-none"
                        @click="showDropdownCabinetNavFooter"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--ellipsis"
                        ></i>
                        <div class="cabinet-nav-footer__link-title">Ещё</div>
                    </a>

                    <div
                        v-if="isDropdownCabinetNavFooter"
                        id="nav-dropdown"
                        class="app-dropdown app-dropdown--nav js-dropdown"
                    >
                        <div class="app-dropdown__main-menu">
                            <router-link
                                to="/account/lists"
                                class="cabinet-nav-list__link cabinet-nav-list__link--dropdown-menu flex flex-align-center js-menu-link"
                            >
                                <i
                                    class="cabinet-nav__icon cabinet-nav__icon--star"
                                ></i>
                                <div
                                    class="cabinet-nav-list__link-title cabinet-nav-list__link-title--dropdown"
                                >
                                    Списки
                                </div>
                            </router-link>
                            <router-link
                                to="/account/orders"
                                class="cabinet-nav-list__link cabinet-nav-list__link--dropdown-menu flex flex-align-center js-menu-link"
                            >
                                <i
                                    class="cabinet-nav__icon cabinet-nav__icon--box-open"
                                ></i>
                                <div
                                    class="cabinet-nav-list__link-title cabinet-nav-list__link-title--dropdown"
                                >
                                    Заказы
                                </div>
                            </router-link>
                        </div>
                        <router-link
                            to="/account/settings"
                            class="app-dropdown__item"
                            >Настройки аккаунта</router-link
                        >
                        <a href="/auth/logout" class="app-dropdown__item"
                            >Выйти</a
                        >
                        <a
                            href="javascript:void(0)"
                            class="app-dropdown__item js-modal-toogle d-md-none"
                            data-target="js-modal-help"
                        >
                            Помощь
                        </a>
                    </div>
                </li>
            </ul>
        </div>

        <div
            ref="dropdownCabinetNavFooter"
            data-target="nav-dropdown"
            class="cabinet-nav-footer cabinet-nav-footer--public flex flex-justify-sb flex-align-center js-dropdown-toogle d-none d-md-flex"
            @click="showDropdownCabinetNavFooter"
        >
            <a
                href="javascript:void(0)"
                class="cabinet-nav-footer__link cabinet-nav-footer__link--user flex flex-align-center js-menu-link"
            >
                <i class="cabinet-nav__icon cabinet-nav__icon--user"></i>
                <div class="cabinet-nav-footer__link-title">
                    {{ user.LoginName }}
                </div>
            </a>
            <a
                href="javascript:void(0)"
                class="cabinet-nav-footer__link cabinet-nav-footer__link--yet flex flex-align-center js-menu-link"
            >
                <i class="cabinet-nav__icon cabinet-nav__icon--ellipsis"></i>
                <div class="cabinet-nav-footer__link-title">Ещё</div>
            </a>
            <div class="cabinet-nav-footer__arrow"></div>

            <div
                v-if="isDropdownCabinetNavFooter"
                id="nav-dropdown"
                class="app-dropdown app-dropdown--nav js-dropdown"
            >
                <div class="app-dropdown__main-menu">
                    <router-link
                        to="/account/lists"
                        class="cabinet-nav-list__link cabinet-nav-list__link--dropdown-menu flex flex-align-center js-menu-link"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--star"
                        ></i>
                        <div
                            class="cabinet-nav-list__link-title cabinet-nav-list__link-title--dropdown"
                        >
                            Списки
                        </div>
                    </router-link>
                    <router-link
                        to="/account/orders"
                        class="cabinet-nav-list__link cabinet-nav-list__link--dropdown-menu flex flex-align-center js-menu-link"
                    >
                        <i
                            class="cabinet-nav__icon cabinet-nav__icon--box-open"
                        ></i>
                        <div
                            class="cabinet-nav-list__link-title cabinet-nav-list__link-title--dropdown"
                        >
                            Заказы
                        </div>
                    </router-link>
                </div>
                <router-link to="/account/settings" class="app-dropdown__item"
                    >Настройки аккаунта</router-link
                >
                <a href="/auth/logout" class="app-dropdown__item">Выйти</a>
                <a
                    href="javascript:void(0)"
                    class="app-dropdown__item js-modal-toogle d-md-none"
                    data-target="js-modal-help"
                >
                    Помощь
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'RetailerNav',

    data() {
        return {
            isHamburgerMenu: false,
            isHamburgerSubMenu: false,
            categorieID: 7,
            isDropdownCabinetNavFooter: false
        }
    },

    computed: {
        ...mapGetters({
            publicCategories: 'publicCategories',
            loading: 'publicCategoriesLoading',
            isHamburgerMenuStore: 'isHamburgerMenuStore'
        }),
        ...mapGetters('cart', ['cartCount']),
        ...mapGetters('user', ['user']),
        categories() {
            return this.publicCategories
                ? this.publicCategories.filter(el =>
                      el.types.reduce((acc, el2) => acc + el2.items_count, 0)
                  )
                : null
        },
        activeCategorie() {
            return this.categories.filter(
                el => el.CategoryID === this.categorieID
            )[0]
        },
        isMobile() {
            return document.documentElement.clientWidth < 767 ? true : false
        }
    },

    watch: {
        isHamburgerMenuStore(value) {
            value === true ? this.showMenu() : null
        }
    },

    created() {
        this.getPublicCategories()
    },

    mounted() {
        document.addEventListener('click', this.closeDropdownCabinetNavFooter)
    },

    beforeDestroy() {
        document.removeEventListener(
            'click',
            this.closeDropdownCabinetNavFooter
        )
    },

    methods: {
        ...mapActions(['getPublicCategories', 'closeHamburgerMenuStore']),
        selectCategoryType(categorieID) {
            this.categorieID = categorieID
            this.isHamburgerMenu = false
            this.isHamburgerSubMenu = true
        },
        showMenu() {
            this.isHamburgerMenu = !this.isHamburgerMenu

            document.documentElement.classList.toggle('no-scroll')
        },
        closeHamburgerMenu() {
            this.isHamburgerMenu = false
            this.isHamburgerSubMenu = false

            document.documentElement.classList.toggle('no-scroll')

            this.closeHamburgerMenuStore()
        },
        hamburgerMenuBack() {
            this.isHamburgerSubMenu = false
            this.isHamburgerMenu = true
        },
        showDropdownCabinetNavFooter() {
            this.isDropdownCabinetNavFooter = !this.isDropdownCabinetNavFooter
        },
        closeDropdownCabinetNavFooter(e) {
            if (window.innerWidth > 1000) {
                if (
                    !this.$refs.dropdownCabinetNavFooter.contains(e.target) ||
                    !this.$el.contains(e.target)
                ) {
                    this.isDropdownCabinetNavFooter = false
                }
            } else {
                if (
                    !this.$refs.dropdownCabinetNavFooterMobile.contains(
                        e.target
                    ) ||
                    !this.$el.contains(e.target)
                ) {
                    this.isDropdownCabinetNavFooter = false
                }
            }
        },
        switchingFromMobileMenu(value) {
            if (value.types) {
                this.$router.push({
                    name: 'CategoryID',
                    params: { id: value.CategoryID }
                })
            } else {
                this.$router.push({
                    name: 'CategoryID',
                    params: {
                        id: value.CategoryID,
                        filter2SubcategoriesFromRoute: value
                    }
                })
            }

            this.closeHamburgerMenu()
        },
        sortedCategoryTypes(types) {
            const typesNew = types
                .slice()
                .sort((a, b) => b.items_count - a.items_count)
                .slice(0, 5)

            return typesNew
        },
        sortedTypesOfActiveCategory(types) {
            const typesNew = types
                .slice()
                .sort((a, b) => b.items_count - a.items_count)

            return typesNew
        }
    }
}
</script>
